import { useParams } from "react-router-dom";
import { Flex, Layout } from "antd";
import { createStyles } from "antd-style";

import { usePublicCompany } from "@av/apps/common-apps/platform/services/companies/public-company";
import { CompanyLogo } from "@av/components/molecules/logo/CompanyLogo";
import { JobsLanguageSelector } from "../molecules/JobsLanguageSelector";

interface JobsResponsiveHeaderProps {
  testIdPrefix?: string;
}

const useStyles = createStyles(({ token, css }) => ({
  header: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${token.marginSM}px;
    height: 104px;
    padding: 0;
    background: transparent;
    border: none;
    line-height: normal;
  `,
}));

export function JobsResponsiveHeader({
  testIdPrefix = "public-jobs-responsive-header",
}: JobsResponsiveHeaderProps) {
  const { Header } = Layout;
  const { styles } = useStyles();
  const { companyId } = useParams();
  const { data: publicCompany } = usePublicCompany(companyId);

  return (
    <Header className={styles.header} data-testid={testIdPrefix}>
      <Flex align="center" gap="small">
        <CompanyLogo size="small" testIdPrefix={testIdPrefix} company={publicCompany} />
      </Flex>
      <Flex align="center" gap="small">
        <JobsLanguageSelector />
      </Flex>
    </Header>
  );
}
